<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import FilterCheckbox from '../../components/filter_checkbox.svelte'
  import FilterDate from '../../components/filter_date.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'
  import { inertiaAction } from '../../lib/inertia_action.js'

  let {
    campaigns = [],
    pagy = { page: 1, pages: 1, count: 0 },
    total_count = 0,
    filters = {},
    list_params = {},
    date_nav = null,
    filter_options = {}
  } = $props()

  // `list_params` is the list's query as the server applied it (defaults spelled out); a
  // filter change builds on it and starts over on page 1. List writes redirect back to the
  // page they came from (referer), so they send nothing but their own data.
  const applyFilters = (changes) => {
    const { page: _page, ...current } = list_params
    router.get('/campaigns', { ...current, ...changes }, { preserveState: true, preserveScroll: true })
  }

  const shiftDate = (days) => {
    if (date_nav) applyFilters({ date: days < 0 ? date_nav.prev : date_nav.next })
  }

  const toggleActive = (item, active) => {
    inertiaAction(router, 'patch', `/campaigns/${item.id}/${active ? 'activate' : 'deactivate'}`)
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    inertiaAction(router, 'delete', `/campaigns/${item.id}`)
  }

  // The server works out which row moved and where (AdminSite::RankedReorder).
  const onReorder = (newItems) => {
    inertiaAction(router, 'patch', '/campaigns/reorder', { ordered_ids: newItems.map((item) => item.id) })
  }
</script>

<Layout>
  <PageHeader title="Campaigns" subtitle="Ranked feed ads scheduled across a college town" count={pagy.count} total={total_count}>
    {#snippet actions()}
      <Button href="/campaigns/new" variant="primary" size="sm" icon="add">New Campaign</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <FilterDate
        nav
        id="campaign-filter-date"
        value={filters.date || ''}
        onchange={(v) => applyFilters({ date: v || 'all' })}
        onshift={shiftDate}
      />

      <FilterSelect
        label="Place"
        width="w-44"
        value={filters.place_id || ''}
        placeholder="All places"
        source="places"
        onchange={(v) => applyFilters({ place_id: v || undefined })}
      />

      <FilterSelect
        label="Feed"
        width="w-44"
        value={filters.feed_id || ''}
        placeholder="All feeds"
        source="feeds"
        onchange={(v) => applyFilters({ feed_id: v || undefined })}
      />

      <FilterSelect
        label="Category"
        width="w-44"
        value={filters.category_id || ''}
        placeholder="All categories"
        options={filter_options.categories ?? []}
        onchange={(v) => applyFilters({ category_id: v || undefined, sub_category_id: undefined })}
      />

      <FilterSelect
        label="Sub Category"
        width="w-44"
        value={filters.sub_category_id || ''}
        placeholder="All sub categories"
        options={filter_options.sub_categories ?? []}
        onchange={(v) => applyFilters({ sub_category_id: v || undefined })}
      />

      <FilterCheckbox label="Active" checked={filters.active_only} onchange={(v) => applyFilters({ active_only: !!v })} />
    {/snippet}
  </FilterBar>

  <EntityList
    entity="campaign"
    rows={campaigns}
    dragEnabled
    onreorder={onReorder}
    onToggle={toggleActive}
    onDelete={archive}
  >
    {#snippet actions(item)}
      <Button href={item.edit_url} variant="ghost" size="xs" square icon="edit" title="Edit" aria-label="Edit" />
      <Button href={item.duplicate_path} variant="ghost" size="xs" square icon="duplicate" title="Duplicate" aria-label="Duplicate" />
      <Button variant="ghost" size="xs" square icon="delete" title="Archive" aria-label="Archive" class="text-error" onclick={() => archive(item)} />
    {/snippet}
  </EntityList>

  <Paginator {...pagy} />
</Layout>
